import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-related-blog',
  templateUrl: './related-blog.component.html',
  styleUrls: ['./related-blog.component.css']
})
export class RelatedBlogComponent {
    @Input() blog:any = {name:"", configuration: {}};
    window:any=<any>window;
    $:any=<any>this.window.$;
    notification:any = {
      danger: (obj:any) => this.window.flowup.signal.emit({name: 'notification', detail: {text: obj.text, type: 'danger'}}),
      success: (obj:any) => this.window.flowup.signal.emit({name: 'notification', detail: {text: obj.text, type: 'success'}})
    };
    openModal = (selector:any) => {
        let modal_wrapper = Array.from(this.window.document.querySelector(`${selector}`).children || []);
        modal_wrapper.forEach((el:any) => el.style.display = 'block');
    };
    closeModal = (selector:any) => {
        let modal_wrapper = Array.from(this.window.document.querySelector(`${selector}`)?.children || []);
        modal_wrapper.forEach((el:any) => el.style.display = 'none');
    };
    obj_model:any = {};
    constructor() {}
    
    /* GESTIONE RELATED OBJECTS */

    openRelatedModal = (obj:any = false) => {
        if(!!obj) this.obj_model = obj;
        this.openModal("#relatedObjectModal");
    };

    closeRelatedModal = () => {
        this.closeModal("#relatedObjectModal");
    };

    getObjects = (pt:any = false) => this.window.bigBucket.getBuckets()[this.window.appInfo.buckets.bigBucket?.container]?.objects?.filter(e => e.configuration.type == "blog" && (!pt || e.public_token == pt)) || [];

    addRelated = (event:any) => {
        if(!event.target.value) return;
        if(this.blog.configuration.related_objects?.includes(event.target.value)) return this.notification.danger({ text: 'Articolo già selezionato!' });
        this.blog.configuration.related_objects = this.blog.configuration.related_objects || [];
        this.blog.configuration.related_objects.push(event.target.value);
        return;
    };

    /**********************/
}